<template>
  <div class="w-100">
    <div class="create-new-test">
      <div class="text-center">
        <v-menu offset-y z-index="10" class="btn-index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="right-btn cust-btn text-tranform-none"
              color="danger"
              @click="onUnassessedOmr"
            >
              Unassessed OMR
            </v-btn>
          </template>
        </v-menu>
      </div>
    </div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section past-test-institute prev-test-tb cat-44">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
            <div class="test-name-search">
              <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearchTest()"
                  solo
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
              </div>
            </div>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                style="position: relative"
                v-for="(item, index) in items"
                :key="item.schedule_id"
                @click="onPreviewClick(item)"
                class="cursor-pointer"
              >
                <td class="text-center fix-130">
                  <div>
                    {{ (item.target_exam.toLowerCase() !== 'jee advanced' && item.test_id) || "N.A" }}
                  </div>
                </td>
                <td class="fix-130">
                  <v-tooltip left content-class="cust-new-tooltip-bottom">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ item.test_name }}
                      </div>
                    </template>
                    <span>
                      <b> Target Exam: </b> {{ item.target_exam }} <br/>
                      <b>Test Pattern: </b> {{ item.omr_pattern_id ? OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                    </span>
                  </v-tooltip>
                </td>
                <td class="dint-120-test">
                  <div class="date-ui">
                    {{ getFormatedDate(item.test_schedule_start) }}
                  </div>
                  <div class="time-ui">
                    {{ getFormatedTime(item.test_schedule_start) }}
                  </div>
                </td>
                <td class="text-center">
                  <template v-if="item.is_shared_test">
                    <v-tooltip 
                      left
                      bottom
                      content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="date-ui" v-bind="attrs" v-on="on">
                          {{ getFormatedDate(item.test_schedule_end) }}
                        </div>
                        <div class="time-ui">
                          {{ getFormatedTime(item.test_schedule_end) }}
                        </div>
                      </template>
                      <span class="text-center tool-tip-position">
                        <b>OMR Upload Deadline: </b><br>
                        <b>{{ getFormatedDate(item.omr_upload_time) }}</b> {{ getFormatedTime(item.omr_upload_time) }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-else>
                    <div class="date-ui">
                      {{ getFormatedDate(item.test_schedule_end) }}
                    </div>
                    <div class="time-ui">
                      {{ getFormatedTime(item.test_schedule_end) }}
                    </div>
                  </template>
                </td>
                <!-- <td class="duration-display">
                  {{ item.target_exam }}
                </td> -->
                <!-- <td class="dint-120-test">
                  <div class="date-ui">
                    {{
                      item.omr_upload_time
                        ? getFormatedDate(item.omr_upload_time)
                        : ""
                    }}
                  </div>
                  <div class="time-ui">
                    {{
                      item.omr_upload_time
                        ? getFormatedTime(item.omr_upload_time)
                        : ""
                    }}
                  </div>
                </td> -->
                <td class="dint-120-test text-center">
                  <span v-if="item.is_shared_test"> AITS </span>
                  <span v-else-if="item.test_type === TEST_TYPE.PREVIOUS_YEAR"> PYT </span>
                  <div v-else>
                    <v-icon
                      v-if="item.is_online_test"
                      @click="deleteScheduleTestPopup(item)"
                      class="eye-icon"
                      >mdi-laptop</v-icon
                    >
                    <img
                      v-else
                      src="../../../assets/img/svg/answer.png"
                      class="omr-icon"
                    />
                  </div>
                </td>
                <!-- <td
                  v-model="showToolTip"
                  :disabled="!buttonHovering"
                  class="dint-120-test text-center"
                >
                  <v-tooltip
                    left
                    bottom
                    content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                  >
                    <template v-slot:activator="{ on }">
                      <v-hover v-model="buttonHovering">
                        <span
                          v-on="on"
                          depressed
                          :class="{
                            'text-transform-none': true,
                            'btn-center': true,
                            'btn-default': true,
                          }"
                        >
                          {{
                            item.batch_name.length < 10
                              ? item.batch_name
                              : item.batch_name.substring(0, 11) + "..."
                          }}</span
                        >
                      </v-hover>
                    </template>
                    <span class="mt-2 dist-120-test">
                      <div class="center-flex">
                        <div class="text-bold  w-20 ">Center:</div>
                        <div class="white-space-wrap text-left">
                          {{ item.center_name }}
                        </div>
                      </div>
                      <div class="center-flex">
                        <div class="text-bold w-20">Batch:</div>
                        <div class="white-space-wrap text-left">
                          {{ item.batch_name }}
                        </div>
                      </div>
                    </span>
                  </v-tooltip>
                </td> -->
                <td class="text-center download-icon">
                  <v-img
                    class="loader-img"
                    src="../../../assets/img/loading.gif"
                    v-if="item.centerDetailsLoading"
                  ></v-img>
                  <v-tooltip
                    v-if="!item.centerDetailsLoading"
                    :value="activeTooltipId === item.schedule_id"
                    content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="download-btn-cp3"
                        color="transparent"
                        depressed
                        @click.stop="toggleTooltip(item.schedule_id)"
                      >
                        <v-img
                          width="23px"
                          src="../../../assets/img/info.svg"
                        ></v-img>
                      </v-btn>
                    </template>

                    <span class="mt-2 dist-120-test">
                      <div class="center-flex">
                        <div class="text-bold w-20">Center:</div>
                        <div class="white-space-wrap text-left">
                          {{ center_name }}
                        </div>
                      </div>
                      <div class="center-flex">
                        <div class="text-bold w-20">Batch:</div>
                        <div class="white-space-wrap text-left">
                          {{batch_name }}
                        </div>
                      </div>
                    </span>
                  </v-tooltip>
                </td>

                <td
                  class="dint-120"
                  v-if="
                    !checkUserType(roleIds.ED) &&
                    ((isOfflineTestVisible().isOnline && item.is_online_test) ||
                      !item.is_online_test)
                  "
                >
                  <div
                    v-if="!item.is_shared_test && hasSTAccess"
                    :class="{ greyText: item.is_shared_test }"
                    @click.stop="ScheduleTestDialog(item)"
                    style="cursor: pointer;"
                  >
                    Reschedule
                  </div>
                </td>
                <td v-else></td>
                <td class="text-center download-icon">
                  <v-img
                    class="loader-img"
                    src="../../../assets/img/loading.gif"
                    v-if="item.status == downloadStatus.IN_PROGRESS"
                  ></v-img>
                  <!-- <v-btn
                    v-else-if="item.status === downloadStatus.COMPLETED"
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click.stop="downloadTestURL(item)"
                  >
                    <v-img src="../../../assets/img/svg/download2.svg"></v-img>
                  </v-btn> -->
                  <v-btn
                    v-else
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click.stop="downloadTest(item)"
                  >
                    <v-img
                      width="23px"
                      src="../../../assets/img/download.svg"
                    ></v-img>
                  </v-btn>
                </td>
                <td
                  class="text-center"
                  v-if="getButtonVisibility(item.is_shared_test ) && (item.target_exam.toLowerCase() !== 'jee advanced') && item.test_type != TEST_TYPE.PREVIOUS_YEAR"
                  @click.stop="openOmrDetailPopUp(item)"
                >
                  Response Details
                </td>
                <!-- <td v-else class="text-center">N.A.</td> -->

                <td
                  class="text-center"
                  :style="
                    item.is_shared_test ? { 'pointer-events': 'none' } : {}
                  "
                >
                  <v-icon
                    v-if="
                      !item.is_shared_test &&
                      item.test_create_status !== TEST_STATUS.IN_PROGRESS &&
                      item.test_create_status !== TEST_STATUS.FAILED &&
                      item.test_type != TEST_TYPE.PREVIOUS_YEAR
                    "
                    @click.stop="confirmDuplicateTest(item)"
                    title="Duplicate Test"
                    :disabled="
                      Boolean(item.is_shared_test) ||
                      item.test_create_status === TEST_STATUS.IN_PROGRESS ||
                      item.test_create_status === TEST_STATUS.FAILED
                    "
                    class="duplicate-btn-cp3"
                  >
                    mdi-file-multiple
                  </v-icon>
                </td>

                <td class="text-center">
                  <span @click.stop="openImportResponsesDialog(item)"
                    :disabled="!item.test_id"
                      v-if="getButtonVisibility(item.is_shared_test ) && (item.target_exam.toLowerCase() !== 'jee advanced') && item.test_type != TEST_TYPE.PREVIOUS_YEAR">
                    Import Responses
                  </span>
                    <span v-else></span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="btm-test-prev-test mt-2 text-italic">
        Click on the Test ID or Test Name to Preview Test
      </div>

      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
    <ImportResponsesDialog
      :status="importResponsesDialogStatus"
      :data="importResponsesData"
      :onClose="onImportResponsesClose"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import ImportResponsesDialog from "@/components/coordinator/Tests/ImportResponsesDialog.vue";

export default {
  name: "Notification",
  components: {
    ImportResponsesDialog
  },
  mounted() {
    this.checkSessionData();
    this.setModuleAccess();
    this.TEST_STATUS = constants.CUSTOM_TEST_STATUS;
    this.downloadStatus = constants.DOWNLOAD_STATUS;
    this.OMR_PATTERN = constants.OMR_PATTERN;
    this.TEST_TYPE = constants.TEST_TYPE;
  },
  data() {
    return {
      headers: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "test_schedule_end",
        order: "DESC",
      },
      selectedExamTypes: [],
      subjects: [],
      teacherSubjectId: [],
      selectedSubject: {},
      centers: [],
      selectedCenterId: [],
      batches: [],
      selectedBatch: null,
      testName: "",
      alertBoxData: null,
      status: false,
      cComponent: "",
      modalwidth: "550px",
      selectedTest: null,
      buttonHovering: false,
      showToolTip: false,
      downloadStatus: {},
      requestIds: [],
      testStatusTimeout: 0,
      toasts: {},
      TEST_STATUS: {},
      TEST_TYPE: {},
      activeTooltipId: null,
      center_name: "",
      batch_name: "",
      importResponsesDialogStatus: false,
      importResponsesData: {},
      shoeResponseDetailButton: true,
    };
  },
  computed: {
    ...mapState("userStore", ["user", "modules"]),
  },
  methods: {
    ...mapActions({
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getTestTarget: "utilStore/getTestTarget",
      getTeacherSubject: "userStore/getTeacherSubject",
      getPastTestList: "testStore/getPastTestInstituteList",
      getCenters: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      createDuplicateTest: "testStore/createDuplicateTest",
      deleteOmr: "testStore/deleteOmr",
      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
      getCenterBatchesBySchedule:
        "centerAndBatchStore/getCenterBatchesBySchedule",
      getCustomTestCount: "testStore/getCustomTestCount",
    }),

    setModuleAccess (){
      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      const currentDate = new Date();
      const qpdModule = modules.find(m => m.module_id === constants.MODULES.QPD);
      this.hasQPDAccess = qpdModule && new Date(qpdModule.expiry_date) > currentDate;
      const stModule = modules.find(m => m.module_id === constants.MODULES.ST);
      this.hasSTAccess = stModule && new Date(stModule.expiry_date) > currentDate;
      const AITsmodule = modules.find(m => m.module_id === constants.MODULES.AITS);
      this.hasAITAccess = AITsmodule ;
    },

    getButtonVisibility(isSharedTest) {
      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      const currentDate = new Date();
      const qpdModule = modules.find(m => m.module_id === constants.MODULES.QPD);
      this.hasQPDAccess = qpdModule && new Date(qpdModule.expiry_date) > currentDate;
      const stModule = modules.find(m => m.module_id === constants.MODULES.ST);
      this.hasSTAccess = stModule && new Date(stModule.expiry_date) > currentDate;
      const AITsmodule = modules.find(m => m.module_id === constants.MODULES.AITS);
      this.hasAITAccess = AITsmodule ;

      if(this.hasQPDAccess &&  this.hasSTAccess){
        return true; 
      } else if(this.hasQPDAccess && this.hasAITAccess  && isSharedTest === 1){
      return true; 
      }else if(this.hasQPDAccess && this.hasSTAccess && this.hasAITAccess){
      return true; 
      }else{
       return false; 
      }
    },

    toggleTooltip(id) {
      this.activeTooltipId = this.activeTooltipId === id ? null : id;
      if (this.activeTooltipId) {
        this.items = this.items.map((item) => ({
          ...item,
          centerDetailsLoading: item.schedule_id === id,
        }));
        this.batch_name = "";
        this.center_name = "";

        this.getCenterBatchesBySchedule({ schedule_id: id })
          .then((response) => {
            if (response && response.length>0) {
              this.batch_name = response[0].batches;
              this.center_name = response[0].center;
            }
          })
          .catch((err) => {
            console.error("Error fetching batch details:", err);
          })
          .finally(() => {
            this.items = this.items.map((item) => ({
              ...item,
              centerDetailsLoading:
                item.schedule_id === id ? false : item.centerDetailsLoading,
            }));
          });
      }
    },

    async confirmDuplicateTest(item) {
      if((this.hasSTAccess && this.hasQPDAccess) || (!this.hasSTAccess && this.hasQPDAccess)) {
       const details = await this.getCustomTestCount({type: 'paper'})
      }
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `Are you sure you want to duplicate the test - ${item.test_name} ?`,
        refId: "duplicateTest",
      };
      this.modalwidth = "350px";
      this.status = true;
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.requestIds = crd.tabDetails[crd.selectedTab].requestIds || []; // load center ids from session
        // this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
      this.getHeaders();
      this.requestGetTestList();
      this.checkDownloadUpdate();
    },
    getHeaders() {
      const headers = [
        {
          text: "Test ID",
          value: "test_id",
          class: "text-center fix-130",
        },
        {
          text: "Test Name",
          value: "test_name",
          class: "fix-130",
        },

        {
          text: "Start Date \n & Time",
          value: "test_schedule_start",
          class: "text-center dint-120-test",
          // hideSort: true,
        },
        {
          text: "End Date \n & Time",
          value: "test_schedule_end",
          class: "text-center dint-120-test",
          // hideSort: true,
        },
        // {
        //  text: "OMR Upload Date \n & Time",
        //  value: "omr_upload_time",
        //  class: "text-center dint-120-test",
        //  hideSort: true,
        // },
        // {
        //   text: "Target Exam",
        //   align: "center",
        //   value: "duration-display",
        //   class: "text-center dint-120",
        //   hideSort: true,
        // },
        {
          text: "Test Type",
          value: "status",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Last Scheduled",
          value: "Batch_Details",
          class: "text-center",
          hideSort: true,
        },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
      ];

      this.headers = _.orderBy(headers, "sortByNumber", "asc");
    },
    downloadTest(item) {
      this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
      this.alertBoxData = {
        ...item,
        tab: item.is_online_test ? "Online" : "Offline",
        isOnlineOfflineTest: this.isOfflineTestVisible(),
      };
      this.status = true;
      this.modalwidth = "550px";
    },
    isOfflineTestVisible() {
      const isOnline = this.modules
        ? this.modules.findIndex((m) => m.module_id === 15) > -1
        : "";
      const isOffline = this.modules
        ? this.modules.findIndex((m) => m.module_id === 14) > -1
        : "";
      return { isOffline, isOnline };
    },

    onSearchTest() {
      this.resetFields();
      this.requestGetTestList();
      // this.updateRouteDetails({ searchText: this.testName });
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    gotoPastTest(item) {
      localStorage.setItem("previousRoute", this.$route.name);
      localStorage.setItem("previousPath", this.$route.path);
      this.$router.push({
        name: "instructions-about-test",
        params: {
          test_id: item.test_id,
          test_institute_id: item.test_institute_id,
        },
      });
    },
    requestGetTestList() {
      let reqData = {
        // test_types: [this.TEST_TYPE.PAST_TEST],
        orderBy: this.orderBy,
        search_query: this.testName,
        test_name: null,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.getPastTestList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;
          this.items = response.list.map((l) => {
            let item = { ...l };
            // item.batch_details = JSON.parse(item.batch_details);
            return item;
          });
          console.log(this.items);
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetCenters() {
      this.centers = [];
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response.map((x, i) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onPreviewClick(test) {
      localStorage.setItem(
        "isOnlineTest",
        test.is_online_test ? "Online" : "Offline"
      );
      localStorage.setItem("test", JSON.stringify(test));
      localStorage.setItem("previousRoute", this.$route.name);
      localStorage.setItem("previousPath", this.$route.path);
      this.$router.push({
        name: test.instructions ? "instructions-about-test" : "preview-test",
        params: {
          test_id: test.test_id,
          test_institute_id: test.test_institute_id,
          test_schedule_id: test.test_schedule_id,
        },
      });
    },
    ScheduleTestDialog(item) {
      // if (
      //   item.test_create_status == constants.CUSTOM_TEST_STATUS.CREATED
      // ) {
      this.selectedTest = { ...item, test_schedule_id: item.schedule_id };
      delete this.selectedTest.schedule_id;
      this.cComponent = "components/coordinator/Tests/ScheduleTestPopup";
      this.modalwidth = "1000px";
      this.status = true;
      this.alertBoxData = {
        selectedTest: { ...this.selectedTest, id: this.selectedTest.test_id },
        isOnlineTest: item.is_online_test ? true : false,
      };
      // }
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onHeaderAction(e) {
      if (e.data && e.data.selectedItems) {
        this.selectedExamTypes = e.data.selectedItems;
        let routeName = this.$route.name;
        let crd = this.getCurrentRouteDetails(routeName);
        crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
        this.setRouteDetails(crd);
        this.onPageChange(1);
      }
    },

    duplicateTest(test) {
      let postData = {
        test_id: test.test_id,
      };
      this.$root.showLoader = true;
      this.createDuplicateTest(postData)
        .then((response) => {
          this.$toasted.success(
            `Congrats!\nYour test has been Duplicated Successfully and is listed under ${
              test.is_online_test ? "Online" : "Offline"
            } Tests  in Customized Tests.`,
            { icon: "info" }
          );
          this.currentPage = 1;
          this.pageSize = 10;
          this.orderBy = {
            field: "test_schedule_end",
            order: "DESC",
          };
          this.requestGetTestList();
        })
        .catch((err) => {
          // this.$toasted.error("Error creating duplicate test.");
          this.$root.showLoader = false;
        });
    },
    onClose(data) {
      this.status = data.status;
      if (data.action === "yes" && data.refId === "deleteTest") {
        this.deleteTest(data.item);
      }
      if (data.action === "reloadTestList") {
        this.requestGetTestList();
      }
      if (data.action === "yes" && data.refId === "duplicateTest") {
        this.duplicateTest(data.item);
      }
      if (data.is_delete) {
        this.openConfirmationPopup(data);
      }
      if (data.action === "no" && data.is_confirm_delete) {
        this.onUnassessedOmr(data.items);
      }
      if (data.action === "yes" && data.is_confirm_delete) {
        this.deleteOMR(data.items);
      }
      if (data && data.data) {
        let domainUrl = process.env.VUE_APP_API_URL;
        let tab = "online";
        if (this.isOfflineTestVisible().isOffline) {
          tab = "offline";
        }
        const modules = JSON.parse(localStorage.getItem("modules")) || [];
        // if (window.location.href.includes('/past-test-institute')) {
        //   console.log('in past test institute')
        //   tab = "offline";
        // }
        const hasValidQPDModules = modules.some(m =>
          (m.module_id === constants.MODULES.QPD));
          tab = hasValidQPDModules ? "offline" : "online";

        let token = sessionStorage.getItem("auth_token");
        let api = "download-test";
        let query = `custom=${tab}&token=${token}&column=${data.isTwoColumn}&isRoughWork=${data.isRoughWork}&pageBreak=${data.pageBreak}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        if (data.download_option === 2) {
          api = "download-answer-key";
          query = `token=${token}`;
        } else if (data.download_option === 3) {
          api = "download-test-solution";
          query = `custom=${tab}&token=${token}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        } else if (data.download_option === 4) {
          api = "download-omr";
          query = `token=${token}&is_test_id_filled=${data.isTestIDFilled}`;
        }
        if (data.data && data.data.is_test_set == 1) {
          query += `&set_number=${data.selectedSet}`;
        }
        let url = domainUrl + `/test/${api}/${data.data.test_id}?${query}`;
        if (data.download_option === 2) {
          window.open(url, "_blank");
        } else {
          this.downloadTestResource(
            `test/${api}/${data.data.test_id}?${query}`,
            data.data
          );
        }
        //   alert(url);
      }
    },
    downloadTestResource(url, test) {
      this.items = this.items.map((item) => {
        if (item.test_id === test.test_id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
        }
        return item;
      });
      this.toasts[test.test_id] = this.$toasted.success(
        "PDF creation under progress. Please do not leave this page",
        { icon: "info", duration: null }
      );

      this.downloadTestPaper(url)
        .then((res) => {
          this.items = this.items.map((item) => {
            if (item.test_id === test.test_id) {
              item.request_id = res.request_id;
            }
            return item;
          }); // console.log(res);
          this.requestIds.push(res.request_id);
          // this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info'})
          this.$forceUpdate();
          console.log(this.items);

          this.checkDownloadUpdate();
          // this.requestGetTestList()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkDownloadUpdate() {
      console.log(this.requestIds, "request_ids");
      if (this.testStatusTimeout) {
        clearInterval(this.testStatusTimeout);
        this.testStatusTimeout = null;
      }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async (res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if (item.url) {
                arr.push({
                  url: data.url,
                  request_id: data.request_id,
                });
              }
              // this.downloadTestURL(item)
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              this.toasts[item?.test_id]?.goAway(0);
              delete this.toasts[item.id];

              this.$toasted.success(
                `Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,
                { icon: "info" }
              );
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);

            await new Promise((resolve) => {
              console.log("Starting delay");
              setTimeout(() => {
                resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {});
    },
    downloadTestURL(item) {
      console.log(item);

      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };

        item.status = null;
        item.request_id = null;
        item.url = null;
        setTimeout(() => {
          this.deleteDownloadData(reqData)
            .then((res) => {})
            .catch((err) => {});
        }, 5000);
      }
    },

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "requestIds":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.requestIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    openOmrDetailPopUp(item) {
      this.cComponent = "components/coordinator/Tests/OmrDetailPopup";
      this.alertBoxData = {
        ...item,
      };
      this.status = true;
      this.modalwidth = "1000px";
    },
    onUnassessedOmr(item) {
      this.cComponent = "components/coordinator/Tests/UnassessOmrDetailPopup";
      this.alertBoxData = {};
      this.status = true;
      this.modalwidth = "1000px";
    },
    openConfirmationPopup(data) {
      this.alertBoxData = {
        ...data,
        message: `Are you sure you want to delete ${
          (data.items &&
            data.items.length &&
            data.items.filter((i) => i.checked).length) ||
          1
        } files`,
        is_confirm_delete: true,
      };
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.modalwidth = "576px";
      this.status = true;
    },
    deleteOMR(items) {
      if (items) {
        this.$root.showLoader = true;
        let omrIds = [];
        if (items && items.id) {
          omrIds = [items.id];
        } else {
          items.map((i) => {
            if (i.checked) {
              omrIds.push(i.id);
            }
          });
        }
        let reqData = {
          omr_ids: omrIds,
        };
        this.deleteOmr(reqData)
          .then((res) => {
            this.$root.showLoader = false;
            this.status = false;
            this.$toasted.success(res.message);
            // if (omrIds && omrIds.length) {
            //   this.items = this.items.filter(i => !omrIds.includes(i.id));
            // } else {
            //   this.items = [];
            // }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    openImportResponsesDialog(item) {
      this.importResponsesData = {
        test_id: item.test_id,
        test_name: item.test_name,
        test_institute_id: item.test_institute_id,
        schedule_id: item.schedule_id
      };
      this.importResponsesDialogStatus = true;
    },
    onImportResponsesClose(data) {
      this.importResponsesDialogStatus = data.status;
      if (data.action === "success") {
        this.requestGetTestList();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  },
  watch: {
    buttonHovering(val) {
      this.showToolTip = val;
    },
    requestIds(val) {
      let routeName = this.$route.name;
      this.updateRouteDetails({
        type: "requestIds",
        data: { requestIds: val },
      });
    },
  },
};
</script>

<style>
.greyText {
  color: grey;
}
</style>
